/* eslint-disable no-useless-escape */
import { LangType } from "client/store"
import { MarkovVariableList } from "../types"


export const MarkovExpressionConvertToView = (
    expression: string,
    variableList: MarkovVariableList,
) => {
    const variablesParsed = MarkovExpressionParseVars(expression)
    let exp = expression

    variablesParsed.forEach((parsed) => {
        const variableId = Number(parsed.split("_")[1]) // where parsed = "var_123"
        if (variableList[variableId]) exp = exp.replace(parsed, variableList[variableId].name)
    })
    return exp
}

type CalcResult = {
    value: number
    error: string
}
export const MarkovExpressionCalc = (
    variableIndex: string, // var_123
    expression: string,
    variableList: MarkovVariableList,
    lang: LangType,
): CalcResult => {
    const variablesParsed = MarkovExpressionParseVars(expression)
    if (variablesParsed.includes(variableIndex)) {
        return {
            value: null,
            error: lang.validationExpressionRecursive,
        }
    }

    if (variablesParsed.length) {
        let exp = expression
        variablesParsed.forEach((parsed) => {
            const variableId = Number(parsed.split("_")[1]) // where parsed = "var_123"
            if (variableList[variableId]) {
                const replaceValue = variableList[variableId].expression
                exp = exp.replace(parsed, Number.isNaN(replaceValue) ? `(${replaceValue})` : replaceValue)
            } else {
                exp = exp.replace(parsed, `empty_variable_${variableId}`)
            }
        })
        return MarkovExpressionCalc(variableIndex, exp, variableList, lang)
    }

    try {
        // eslint-disable-next-line no-eval
        const value = eval(expression)
        return {
            value,
            error: null,
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
        return {
            value: null,
            error: lang.validationExpression,
        }
    }
}

export const MarkovExpressionParseVars = (expression: string) => {
    const variables: string[] = expression.match(/var_(\d+)/g) || []
    return variables.sort((a, b) => b.length - a.length)
    // sort to ["var_1234", "var_123", "var_12", "var_1"], otherwise replace will be incorrect
}

export const MarkovExpressionParseElements = (value: string) => (
    value.match(/(\d+(?:\.\d+)?|[-+^\/*().]|\s|\w+)/g) || []
    // (                     # start capture group
    //     \d+(?:\.\d+)?     # match a number
    //     |                 # OR
    //     [-+^\/*().]       # match one of the symbols
    //     |                 # OR
    //     \s                # match 1 space
    //     |                 # OR
    //     \w+               # match 1 or more word characters
    // )                     # end capture group
)

// check if target value is a word
export const MarkovExpressionTargetIsWord = (value: string) => {
    const reference = /\w+/g
    return reference.test(value)
}

// allow numbers, letters, calculation signs, underline, spaces
export const MarkovExpressionAllowedCharacters = (value: string) => {
    const reference = /[0-9]|[a-z]|[A-Z]|[-+^\/*()_.]|\s+/g
    return reference.test(value)
}

// allow numbers, letters, underline
export const MarkovVariableAllowedCharacters = (value: string) => {
    const reference = /[0-9]|[a-z]|[A-Z]|[_]/g
    return reference.test(value)
}
